import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { FlexBetween } from '../../../global/commonStyle';
const ProfileDropdown = styled.div`
  padding: var(--space-20);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;

const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
`;

const DropTitle = styled.h5`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin-block: var(--space-0);
`;
const Customer = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
  .angleDown-icon {
    transition: transform var(--transition-normal) ease;
  }
  .angleDown-icon.rotate {
    transform: rotate(180deg);
  }
`;

const InvoiceType = styled.div`
  padding-block: var(--space-16);
  box-shadow: var(--top-border), var(--bottom-border);
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;
const FormButton = styled.div`
  display: flex;
  gap: var(--space-8);
`;

const RadioWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-12);
  .radio-Button {
    ${Typography.body_sm}
  }
`;

export { ProfileDropdown, Customer, DropTitle, InvoiceType, FormButton, RadioWrapper, TopSection };
